import type { TaskListPreferences } from "@/types/list";

export const GROUP_HEADER_HEIGHT = 58; // Fixed height for group headers
export const TASK_ROW_HEIGHT = 39; // Height for regular task rows - TODO:  for one reasong 39 works but 38 is a pixel too small
export const ACTION_BAR_HEIGHT = 40; // Height for action bar (group footer-)

export const SUBTASK_INDENT_WIDTH = 24; // Width for subtask indent

export const DEFAULT_GROUPING = null; // no grouping by default
export const DEFAULT_SORTING = "createdAt";
export const cellPadding = "px-3 py-2 "; // cell padding for the table cells

export const DEFAULT_TASKLIST_PREFERENCES: TaskListPreferences = {
    "taskList.grouping": DEFAULT_GROUPING,
    "taskList.groupOrder": "asc",
    "taskList.sorting": DEFAULT_SORTING,
    "taskList.taskOrder": "asc",
    "taskList.completedTasks": "all",
    "taskList.attributes": [
        { id: "taskStatus", name: "Status", type: "builtin" },
        { id: "priority", name: "Priority", type: "builtin" },
        { id: "dueDate", name: "Due date", type: "builtin" },
        { id: "assignee", name: "Assignee", type: "builtin" },
        { id: "createdBy", name: "Created by", type: "builtin" },
    ],
    "taskList.manualOrder": [],
    "taskList.manualSubtaskOrder": {},
};
